import React from 'react';
import { Input, Button } from '@crisellevaldez/speculo-ui';
import { Search, RotateCw } from 'lucide-react';

interface ConvertTableHeaderProps {
  searchQuery: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onRefresh: () => Promise<void>;
  isLoading: boolean;
  totalFlows: number;
}

export const ConvertTableHeader: React.FC<ConvertTableHeaderProps> = ({
  searchQuery,
  onSearchChange,
  onRefresh,
  isLoading,
  totalFlows,
}) => {
  return (
    <div className="flex gap-2 items-center">
      <Input
        placeholder="Search by name..."
        startIcon={<Search className="text-gray-400" size={20} />}
        value={searchQuery}
        onChange={onSearchChange}
        className="w-full"
      />
      <Button
        variant="secondary"
        size="sm"
        className="p-2 justify-center h-9"
        onClick={onRefresh}
        disabled={isLoading}
      >
        <RotateCw className={`h-4 w-4 ${isLoading ? 'animate-spin' : ''}`} />
      </Button>
    </div>
  );
};
